import { NavLink, Outlet, useNavigate } from "react-router-dom";
import {
  LayoutDashboard, Building2, FileStack, FileText, LogOut, ChevronRight, Sparkles,
} from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import { TID } from "@/lib/testIds";
import ThemeToggle from "@/components/ThemeToggle";

const NAV = [
  { to: "/master/dashboard", label: "Visão Geral", icon: LayoutDashboard, tid: TID.masterNavDashboard },
  { to: "/master/tenants", label: "Empresas", icon: Building2, tid: TID.masterNavTenants },
  { to: "/master/templates", label: "Modelos prontos", icon: FileStack, tid: TID.masterNavTemplates },
  { to: "/master/audit", label: "Histórico de alterações", icon: FileText, tid: TID.masterNavAudit },
];

export default function MasterLayout() {
  const auth = useAuth();
  const nav = useNavigate();

  const handleLogout = async () => {
    await auth.logout();
    nav("/master/login", { replace: true });
  };

  return (
    <div className="min-h-screen bg-background text-foreground flex">
      {/* Sidebar */}
      <aside
        data-testid={TID.masterSidebar}
        className="w-64 shrink-0 border-r border-border bg-card flex flex-col"
      >
        <div className="px-5 py-5 border-b border-border flex items-center gap-2.5">
          <img src="/sua-plataforma-logo.png" alt="SUA PLATAFORMA" className="w-9 h-9 rounded-lg shrink-0 object-contain bg-secondary p-1" />
          <div>
            <div className="font-display font-bold leading-none">SUA PLATAFORMA</div>
            <div className="text-[10px] uppercase tracking-[0.2em] text-muted-foreground mt-1">Painel da Matriz</div>
          </div>
        </div>

        <nav className="flex-1 px-3 py-4 space-y-1">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              data-testid={n.tid}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 rounded-md text-sm transition-colors ${
                  isActive
                    ? "bg-foreground text-background"
                    : "text-muted-foreground hover:text-foreground hover:bg-muted"
                }`
              }
            >
              <n.icon className="w-4 h-4" strokeWidth={1.6} />
              <span className="font-medium">{n.label}</span>
            </NavLink>
          ))}
        </nav>

        <div className="px-3 py-4 border-t border-border space-y-2">
          <div className="flex items-center justify-between gap-2 px-1">
            <div className="flex items-center gap-2 px-2 text-xs text-muted-foreground truncate">
              <Sparkles className="w-3.5 h-3.5 shrink-0" /> <span className="truncate">{auth?.user?.email}</span>
            </div>
            <ThemeToggle testId="master-theme-toggle" />
          </div>
          <button
            onClick={handleLogout}
            data-testid={TID.masterLogout}
            className="w-full flex items-center justify-between px-3 py-2 rounded-md text-sm text-muted-foreground hover:text-destructive hover:bg-destructive/10 transition-colors"
          >
            <span className="inline-flex items-center gap-2"><LogOut className="w-4 h-4" /> Sair</span>
            <ChevronRight className="w-3.5 h-3.5" />
          </button>
        </div>
      </aside>

      <main className="flex-1 min-w-0">
        <Outlet />
      </main>
    </div>
  );
}
